import * as tslib_1 from "tslib";
import { ElementRef, NgZone, OnInit } from '@angular/core';
import { AgmMap, MapsAPILoader } from '@agm/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Location, LocationPin } from '@ml/locations/types';
var CustomerLocationModalComponent = /** @class */ (function () {
    function CustomerLocationModalComponent(mapsAPILoader, ngZone, dialogRef, data) {
        this.mapsAPILoader = mapsAPILoader;
        this.ngZone = ngZone;
        this.dialogRef = dialogRef;
        this.data = data;
        this.START_ZOOM = 16;
        this.POLYGON = 'polygon';
        this.MARKER = 'marker';
        this.managerOptions = {
            drawingMode: null,
            drawingControl: true,
            drawingControlOptions: {
                drawingModes: [this.POLYGON]
            },
            polygonOptions: {
                draggable: false,
                editable: true,
                strokeColor: '#1b5e20',
                strokeOpacity: 0.6,
                fillColor: '#1b5e20',
                fillOpacity: 0.35
            },
            markerOptions: {
                draggable: true
            }
        };
        this.inputForm = new FormControl('', [Validators.required]);
        this.oneTimeToggle = false;
        this.oneTimeLocationControl = new FormControl(false);
        this.startLatitude = 49.53336;
        this.startLongitude = 5.98863;
        this.oneTimeToggle = this.data ? this.data.oneTimeToggle : false;
        if (this.data && this.data.location) {
            this.startLatitude = this.data.location.startPoint.lat;
            this.startLongitude = this.data.location.startPoint.long;
        }
        this.disable = this.data && this.data.disable;
        if (this.disable) {
            this.inputForm.disable();
            this.managerOptions.polygonOptions.editable = false;
            this.managerOptions.markerOptions.draggable = false;
        }
    }
    CustomerLocationModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.customerLocation = this.data ? this.data.location : null;
        this.pins = this.customerLocation ? this.customerLocation.pins.slice() : [];
        this.mapsAPILoader.load().then(function () {
            var autocomplete = new google.maps.places.Autocomplete(_this.searchElementRef.nativeElement);
            autocomplete.addListener('place_changed', function () {
                _this.ngZone.run(function () {
                    // get the place result
                    var place = autocomplete.getPlace();
                    // verify result
                    if (place.geometry === undefined || place.geometry === null) {
                        return;
                    }
                    // set latitude, longitude and zoom
                    _this.startLatitude = place.geometry.location.lat();
                    _this.startLongitude = place.geometry.location.lng();
                });
            });
        });
    };
    CustomerLocationModalComponent.prototype.onRemovePin = function (index) {
        this.pins.forEach(function (value) { return value.marker.setMap(null); });
        var pins = this.pins.filter(function (value, indexValue) { return indexValue !== index; });
        this.pins = this.getPins(pins);
    };
    CustomerLocationModalComponent.prototype.onPrimaryPin = function (index) {
        this.pins.forEach(function (value) { return value.marker.setMap(null); });
        var pins = this.pins.map(function (value, valueIndex) { return (tslib_1.__assign({}, value, { primary: valueIndex === index })); });
        this.pins = this.getPins(pins);
    };
    Object.defineProperty(CustomerLocationModalComponent.prototype, "valid", {
        get: function () {
            var valid = this.inputForm.valid && this.pins.length > 0;
            if (this.data && this.data.fieldRequired) {
                return valid && !!this.selectedShape;
            }
            return valid;
        },
        enumerable: true,
        configurable: true
    });
    CustomerLocationModalComponent.prototype.onCancel = function () {
        this.dialogRef.close();
    };
    CustomerLocationModalComponent.prototype.onSubmit = function () {
        var location = new Location();
        location.name = this.inputForm.value;
        if (this.selectedShape && this.selectedShape.getPath()) {
            location.points = this.selectedShape
                .getPath()
                .getArray()
                .map(function (path) {
                return {
                    lat: path.lat(),
                    long: path.lng()
                };
            });
        }
        else {
            location.points = [];
        }
        location.pins = this.pins.map(function (value) {
            delete value.marker;
            return value;
        });
        if (this.customerLocation) {
            location.id = this.customerLocation.id;
        }
        location.customer =
            this.data && this.data.customer ? this.data.customer : null;
        if (this.oneTimeLocationControl.value) {
            location.customer = null;
        }
        this.dialogRef.close(location);
    };
    CustomerLocationModalComponent.prototype.onMapReady = function (map) {
        this.map = map;
        this.initDrawingManager();
    };
    CustomerLocationModalComponent.prototype.onClear = function () {
        if (this.selectedShape) {
            this.selectedShape.setMap(null);
            this.selectedShape = null;
        }
        this.pins.forEach(function (value) { return value.marker.setMap(null); });
        this.pins = [];
        this.updateDrawingModesOption([this.POLYGON]);
        this.drawingManager.setDrawingMode(this.POLYGON);
    };
    CustomerLocationModalComponent.prototype.initDrawingManager = function () {
        var _this = this;
        this.drawingManager = new google.maps.drawing.DrawingManager(this.managerOptions);
        this.drawingManager.setMap(this.map);
        if (this.customerLocation) {
            this.drawInitialLocation();
        }
        google.maps.event.addListener(this.drawingManager, 'polygoncomplete', function (event) {
            _this.drawingManager.setDrawingMode(null);
            _this.updateDrawingModesOption([]);
            _this.selectedShape = event;
        });
        google.maps.event.addListener(this.map, 'click', function (event) {
            _this.ngZone.run(function () {
                _this.onAddPin(event);
            });
        });
    };
    CustomerLocationModalComponent.prototype.drawInitialLocation = function () {
        var points = this.customerLocation.points.map(function (point) { return ({
            lat: point.lat,
            lng: point.long
        }); });
        this.pins = this.getPins(this.customerLocation.pins.slice());
        if (points.length > 0) {
            this.selectedShape = new google.maps.Polygon(tslib_1.__assign({ paths: points, map: this.map }, this.managerOptions.polygonOptions));
        }
        if (this.selectedShape) {
            this.updateDrawingModesOption([]);
            this.drawingManager.setDrawingMode(null);
        }
        else {
            this.updateDrawingModesOption([this.POLYGON]);
            this.drawingManager.setDrawingMode(null);
        }
        this.inputForm.setValue(this.customerLocation.name);
    };
    CustomerLocationModalComponent.prototype.updateDrawingModesOption = function (modes) {
        this.drawingManager.setOptions({
            drawingControlOptions: {
                drawingModes: modes
            }
        });
    };
    CustomerLocationModalComponent.prototype.onAddPin = function (event) {
        var pin = new LocationPin();
        pin.lat = event.latLng.lat();
        pin.long = event.latLng.lng();
        pin.primary = this.pins.length === 0;
        pin.marker = this.getMarker(pin, this.pins.length);
        pin.description = '';
        this.addDragEndListener(pin);
        this.pins = this.pins.concat([pin]);
    };
    CustomerLocationModalComponent.prototype.updatePins = function () {
        var _this = this;
        this.pins = this.pins.map(function (value, index) {
            var pin = tslib_1.__assign({}, value, { marker: _this.getMarker(value, index) });
            _this.addDragEndListener(pin);
            return pin;
        });
    };
    CustomerLocationModalComponent.prototype.getPins = function (pins) {
        var _this = this;
        return pins.map(function (value, index) {
            var pin = tslib_1.__assign({}, value, { marker: _this.getMarker(value, index) });
            _this.addDragEndListener(pin);
            return pin;
        });
    };
    CustomerLocationModalComponent.prototype.addDragEndListener = function (pin) {
        var _this = this;
        pin.marker.addListener('dragend', function (event) {
            _this.ngZone.run(function () {
                pin.lat = event.latLng.lat();
                pin.long = event.latLng.lng();
            });
        });
    };
    CustomerLocationModalComponent.prototype.getMarker = function (pin, index) {
        var color = pin.primary ? 'green' : 'yellow';
        return new google.maps.Marker({
            position: {
                lat: pin.lat,
                lng: pin.long
            },
            label: "" + (index + 1),
            map: this.map,
            icon: this.pinSymbol(color),
            draggable: !this.disable
        });
    };
    CustomerLocationModalComponent.prototype.pinSymbol = function (color) {
        return {
            path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
            fillColor: color,
            fillOpacity: 1,
            strokeColor: '#000',
            strokeWeight: 1,
            scale: 1.4,
            labelOrigin: new google.maps.Point(0, -29)
        };
    };
    return CustomerLocationModalComponent;
}());
export { CustomerLocationModalComponent };
